<template>
  <v-dialog v-model="dialog" width="1200">
    <v-card class="scroll_extended">
      <v-card-title class="grey--text text-subtitle-1">
        <v-icon color="green" class="mr-2">mdi-clipboard-text-outline</v-icon>
        {{ id_evento ? "Modifica Evento" : "Nuovo Evento" }}
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6">
            <div class="text-overline grey--text text--darken-1">
              Trattamento
            </div>
            <v-row>
              <v-col cols="7">
                <v-dialog
                  ref="dialog"
                  v-model="dialog_data"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Data Intervento"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" scrollable locale="IT">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialog_data = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="5">
                <v-combobox
                  v-model="volume_acqua"
                  :items="volumi_acqua_disponibili"
                  label="Volume Acqua"
                  prepend-inner-icon="mdi-water-outline"
                  suffix="L"
                  outlined
                  hide-details
                  hint="Scegli un valore già usato o scrivine uno nuovo (facoltativo, per la % di diluizione)"
                />
              </v-col>
            </v-row>
            <div class="text-overline grey--text text--darken-1 mt-2">
              Prodotti Utilizzati
            </div>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="fitofarmaci_utiliz"
                  prepend-inner-icon="mdi-medication-outline"
                  label="Prodotto Utilizzato"
                  :items="fitofarmaci"
                  item-text="dettagli.prodotto"
                  item-value="id_fitofarmaco"
                  outlined
                  hide-details
                  chips
                  multiple
                />
              </v-col>
            </v-row>
            <v-row v-if="fitofarmaci_utiliz">
              <v-col
                cols="6"
                v-for="(id_fito, index) in fitofarmaci_utiliz"
                :key="id_fito"
              >
                <v-text-field
                  v-model="qta_fitofarmaci[index]"
                  outlined
                  :label="fitofarmaco(id_fito).dettagli.prodotto"
                  suffix="Kg/Lt."
                  :hint="
                    diluizione(qta_fitofarmaci[index]) !== null
                      ? 'Diluizione ≈ ' + diluizione(qta_fitofarmaci[index]).toFixed(2) + '%'
                      : ''
                  "
                  persistent-hint
                  :error="
                    qta_fitofarmaci[index]
                      ? !isNumeroValido(qta_fitofarmaci[index])
                      : false
                  "
                />
              </v-col>
            </v-row>
            <div class="text-overline grey--text text--darken-1 mt-2">
              Dettagli Trattamento
            </div>
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="lista_avversita"
                  prepend-inner-icon="mdi-bug"
                  label="Avversità"
                  :items="avversita"
                  item-text="nome"
                  item-value="id"
                  outlined
                  hide-details
                  chips
                  multiple
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  prepend-inner-icon="mdi-spa"
                  outlined
                  :items="lista_fasi_fenologiche"
                  label="Fase Fenologica"
                  v-model="fase_fenologica"
                  item-value="cod"
                  item-text="text"
                  chips
                  hide-details
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <div class="text-overline grey--text text--darken-1">
              Colture Trattate
            </div>
            <v-sheet outlined rounded class="pa-3 mb-3">
              <div class="d-flex align-center justify-space-between mb-2">
                <div class="d-flex align-center">
                  <v-icon small color="grey" class="mr-2">mdi-greenhouse</v-icon>
                  <span class="text-caption grey--text">Posizione (mappa)</span>
                </div>
                <v-btn
                  small
                  outlined
                  color="green"
                  @click="$refs.serra_picker.open()"
                >
                  <v-icon small class="mr-1">mdi-map-marker-plus-outline</v-icon
                  >{{ id_serre.length ? "Modifica" : "Scegli dalla mappa" }}
                </v-btn>
              </div>
              <div v-if="id_serre.length" class="d-flex flex-wrap" style="gap: 6px">
                <v-chip
                  v-for="id_serra in id_serre"
                  :key="id_serra"
                  small
                  outlined
                  close
                  color="green darken-1"
                  @click:close="
                    id_serre = id_serre.filter((id) => id !== id_serra)
                  "
                >
                  <v-icon x-small left>mdi-greenhouse</v-icon>
                  {{ nome_serra(id_serra) }}
                </v-chip>
              </div>
              <div v-else class="text-caption grey--text font-italic">
                Nessuna serra selezionata
              </div>
            </v-sheet>
            <SerraPickerDialog ref="serra_picker" v-model="id_serre" />

            <template v-if="id_serre.length">
              <v-tabs v-model="tab_serra" show-arrows>
                <v-tab v-for="id_serra in id_serre" :key="id_serra"
                  >{{ nome_serra(id_serra) }}
                  <v-chip
                    v-if="count_colture(id_serra) !== null"
                    x-small
                    class="ml-2"
                    :color="count_colture(id_serra) ? 'green lighten-4' : 'grey lighten-3'"
                    >{{ count_colture(id_serra) }}</v-chip
                  >
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab_serra">
                <v-tab-item v-for="id_serra in id_serre" :key="id_serra">
                  <v-card
                    v-if="entry_serra(id_serra)"
                    tile
                    flat
                    class="scroll"
                  >
                    <div
                      v-if="entry_serra(id_serra).colture.length"
                      class="d-flex align-center px-2 py-1"
                    >
                      <v-checkbox
                        :input-value="!!check_all_serra[id_serra]"
                        @change="toggle_all_serra(id_serra, $event)"
                        color="green"
                        dense
                        hide-details
                        class="ma-0 pa-0 mr-1"
                      />
                      <span class="text-caption grey--text">
                        Seleziona tutti ({{ entry_serra(id_serra).colture.length }})
                      </span>
                    </div>
                    <v-divider v-if="entry_serra(id_serra).colture.length" />
                    <template
                      v-for="(gruppo, gi) in gruppi_colture(entry_serra(id_serra))"
                    >
                      <div :key="gruppo.id_prodotto + '-header'" class="px-3 pt-3 pb-1 d-flex align-center">
                        <v-avatar size="26" class="mr-2">
                          <v-img :src="avatar_img(gruppo.id_prodotto)" />
                        </v-avatar>
                        <div class="text-body-2 font-weight-medium">
                          {{ nome_coltura(gruppo.id_prodotto)[0] }}
                          <span
                            v-if="nome_coltura(gruppo.id_prodotto)[1]"
                            class="grey--text text-caption"
                            >— {{ nome_coltura(gruppo.id_prodotto)[1] }}</span
                          >
                        </div>
                      </div>
                      <v-list-item
                        v-for="coltura in gruppo.items"
                        :key="coltura.coltura.id"
                        dense
                        class="pl-8"
                        @click="
                          toggle_item({
                            lotto: coltura.lotto,
                            id: coltura.coltura.id_prodotto,
                          })
                        "
                      >
                        <v-list-item-avatar size="22" class="mr-2">
                          <v-img
                            v-if="fornitore_logo(coltura.lotto)"
                            :src="fornitore_logo(coltura.lotto)"
                          />
                          <v-icon v-else small color="grey lighten-1"
                            >mdi-domain</v-icon
                          >
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-subtitle class="text-caption">
                            <template v-if="fornitore(coltura.lotto)"
                              >{{ fornitore(coltura.lotto).nome }} · </template
                            >Lotto
                            {{ lotto(coltura.lotto) ? lotto(coltura.lotto).codice : "…" }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-checkbox
                            readonly
                            :input-value="
                              item_selected({
                                lotto: coltura.lotto,
                                id: coltura.coltura.id_prodotto,
                              })
                            "
                            hide-details
                          />
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider
                        v-if="gi < gruppi_colture(entry_serra(id_serra)).length - 1"
                        :key="gruppo.id_prodotto + '-div'"
                        class="mx-3"
                      />
                    </template>
                    <div
                      v-if="!entry_serra(id_serra).colture.length"
                      class="text-caption grey--text pa-3"
                    >
                      Nessuna coltura trovata per questa serra
                    </div>
                  </v-card>
                  <v-card v-else tile flat class="scroll d-flex align-center justify-center">
                    <div class="text-caption grey--text d-flex align-center">
                      <v-progress-circular
                        indeterminate
                        size="16"
                        width="2"
                        color="grey"
                        class="mr-2"
                      />
                      Caricamento…
                    </div>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </template>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              outlined
              label="Note"
              prepend-inner-icon="mdi-note-text-outline"
              v-model="note"
              hide-details
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="dialog = false">Annulla</v-btn>
        <v-btn
          outlined
          color="green"
          @click="invia_evento()"
          :disabled="
            !lista_avversita.length ||
            !fitofarmaci_utiliz.length ||
            (!id_evento && !id_serre.length) ||
            qta_fitofarmaci.length != fitofarmaci_utiliz.length ||
            !num_box_ok
          "
          :loading="loading_nuovo"
        >
          <v-icon class="mr-2">mdi-content-save</v-icon>
          {{ id_evento ? "Salva Modifiche" : "Salva Evento" }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import nuovo_evento_mixin from "../mixin/nuovo_evento_mixin";
import SerraPickerDialog from "@/components/PianoColtivazione/Desktop/SerraPickerDialog.vue";
export default {
  components: { SerraPickerDialog },
  mixins: [nuovo_evento_mixin],
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #bbbbbb;
}
.scroll {
  height: 350px;
  overflow-y: scroll;
}

.scroll_extended {
  max-height: 95vh;
  overflow-y: scroll;
}
</style>